import { ACTION_TYPES } from 'Data/actions';
import { EMPTY_ARR } from 'Services/constants/empty';

const initialState = EMPTY_ARR;

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.STORE_RESET:
      return initialState;
    case ACTION_TYPES.SNACKBAR_DELETE:
      return state.filter((snackbar) => snackbar.id !== action.payload.snackbarId);
    case ACTION_TYPES.SNACKBAR_CREATE:
      return state.concat(action.payload);
    default:
      return state;
  }
};
